import React from "react";
import MyJobs from "./MyJobs";

export default function MyWork() {
  return <MyJobs scope="assigned" title="My work" subtitle="Jobs you've won — track status and submit reports" />;
}
